import { API_BASE_URL_V2, API_BASE_URL, ADESION_URL } from 'config'

import axios from 'axios'
import PropTypes from 'prop-types'
import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'
import DataLogicV2 from 'containers/AppV2/logic'
import ResultsLogicV2 from 'containers/ResultsV2/logic'
import { csObjectFromUnderscore, csObjectToUnderscore } from 'utils'

import omit from 'lodash/omit'
import mapValues from 'lodash/mapValues'
import { sendGevent } from 'utils'

const PATCH_ENDPOINT = `${API_BASE_URL_V2}/public/simulation/:code/`
const DISTRICTS_ENDPOINT = `${API_BASE_URL}/public/district/`
const MUNICIPALITIES_ENDPOINT = `${API_BASE_URL}/public/municipality/`
const SUBSCRIBE_PRICE_LIST_ENDPOINT = `${ADESION_URL}/public/subscribe-price-list/`

const PERSONAL_VALUES = {
  name: { value: '', valid: false },
  surName: { value: '', valid: false },
  nif: { value: '', valid: false },
  email: { value: '', valid: false },
  phone: { value: '', valid: false },
  contact: { value: 'e', valid: true },
  contactTime: { value: '', valid: false },
}

const ADDRESS_VALUES = {
  street: { value: '', valid: false },
  door: { value: '', valid: false },
  floor: { value: '', valid: false },
  district: { value: '', valid: false },
  municipality: { value: '', valid: false },
  billingAddress: { value: 'e', valid: false },
  directDebit: { value: 'd', valid: false },
  billingStreet: { value: '', valid: false },
  billingDoor: { value: '', valid: false },
  billingFloor: { value: '', valid: false },
  billingDistrict: { value: '', valid: false },
  billingMunicipality: { value: '', valid: false },
  electronicBilling: { value: 'e', valid: false },
}

const DEFAULT_PROPS = {
  personal: PERSONAL_VALUES,
  billing: ADDRESS_VALUES,
  electric: {
    currentEntityElectric: { value: '', valid: false, designation: 'ee' },
    cpe: { value: '', valid: false },
    potency: { value: '', valid: false },
    tariff: { value: '', valid: false },
    cycle: { value: '', valid: false },
  },

  gas: {
    currentEntityGas: { value: '', valid: false, designation: 'eg' },
    cui: { value: '', valid: false },
    tier: { value: '', valid: false },
  },
  confirm: {
    allowDataSharing: { value: false, valid: false },
  },
}

export default kea({
  connect: {
    props: [DataLogicV2, ['translations', 'values', 'userLoggedIn']],
    actions: [ResultsLogicV2, ['setSimulationResults', 'userProfile']],
  },

  actions: () => ({
    joinTariff: (code) => ({ code }),
    submitForm: (form, omit, callback) => ({ form, omit, callback }),
    setSubmitting: (submitting) => ({ submitting }),
    setAdhesionResponse: (data) => ({ data }),
    setAdhesionError: (error) => ({ error }),
    setConfirmationError: (error) => ({ error }),

    resetForm: () => ({}),
    setFormValues: (selected) => selected,
    deleteFormValue: (key) => ({ key }),
    setEditError: (message) => ({ message }),
    setInvalid: (invalid) => ({ invalid }),
    recheckValids: () => ({}),
    setFirstSet: (firstSet) => ({ firstSet }),

    setDistricts: (districts) => ({ districts }),
    setMunicipalities: (municipalities) => ({ municipalities }),
    setBillingMunicipalities: (municipalities) => ({ municipalities }),
    setError: (error) => ({ error }),

    fetchDistricts: () => ({}),
    fetchMunicipalities: (id, type) => ({ id, type }),
  }),
  reducers: ({ actions }) => ({
    formValues: [
      DEFAULT_PROPS,
      PropTypes.object,
      {
        [actions.setFormValues]: (state, payload) => ({ ...state, ...payload }),
        [actions.resetForm]: () => ({ ...DEFAULT_PROPS }),
        [actions.deleteFormValue]: (state, payload) => omit(state, payload.key),
        [actions.recheckValids]: (_, payload) => {
          let current = { ..._ }

          current = mapValues(current, (list1, key1) => {
            return mapValues(list1, (item, key) => {
              return { ...item, valid: false }
            })
          })

          return current
        },
        [actions.setInvalid]: (_, payload) => {
          let current = { ..._ }
          const key = Object.keys(payload.invalid)[0]
          const list = payload.invalid[key]

          current = mapValues(current, (list1, key1) => {
            return mapValues(list1, (item, key) => {
              return { ...item, valid: false }
            })
          })

          mapValues(list, (valid, valueKey) => {
            current[key][valueKey].valid = valid
          })

          return current
        },
        // [actions.setInvalid]: (state, payload) => {
        //   let current = { ...state }

        //   const key = Object.keys(payload.invalid)[0]
        //   const list = payload.invalid[key]

        //   mapValues(list, (valid, valueKey) => {
        //     current[key][valueKey].valid = valid
        //   })

        //   return current
        // },
      },
    ],
    loading: [
      false,
      PropTypes.bool,
      {
        [actions.joinTariff]: () => true,
        [actions.setFormValues]: () => false,
        [actions.resetForm]: () => false,
        [actions.deleteFormValue]: () => false,
        [actions.setEditError]: () => false,
      },
    ],
    submitting: [
      false,
      PropTypes.bool,
      {
        [actions.setSubmitting]: (_, payload) => payload.submitting,
      },
    ],
    error: [
      false,
      PropTypes.object,
      {
        [actions.setError]: (state, payload) => payload.error,
        [actions.setDistricts]: () => false,
        [actions.setMunicipalities]: () => false,
      },
    ],
    districts: [
      [],
      PropTypes.array,
      {
        [actions.setDistricts]: (_, payload) => payload.districts,
      },
    ],
    municipalities: [
      [],
      PropTypes.array,
      {
        [actions.setMunicipalities]: (_, payload) => payload.municipalities,
      },
    ],
    billingMunicipalities: [
      [],
      PropTypes.array,
      {
        [actions.setBillingMunicipalities]: (_, payload) =>
          payload.municipalities,
      },
    ],
    adhesionError: [
      null,
      PropTypes.object,
      {
        [actions.setAdhesionError]: (_, payload) => payload.error,
        [actions.resetForm]: () => null,
      },
    ],
    adhesionResponse: [
      null,
      PropTypes.object,
      {
        [actions.setAdhesionResponse]: (state, payload) => payload.data,
        [actions.resetForm]: () => null,
      },
    ],
    confirmationError: [
      false,
      PropTypes.bool,
      {
        [actions.setConfirmationError]: (state, payload) => payload.error,
        [actions.resetForm]: () => false,
      },
    ],
    firstSet: [
      true,
      PropTypes.bool,
      {
        [actions.setFirstSet]: (_, payload) => payload.firstSet,
        [actions.resetForm]: () => true,
      },
    ],
  }),
  takeLatest: ({ actions, workers }) => ({
    [actions.joinTariff]: workers.joinTariff,
    [actions.submitForm]: workers.submitForm,
    [actions.fetchDistricts]: workers.fetchDistricts,
    [actions.fetchMunicipalities]: workers.fetchMunicipalities,
  }),

  start: function*() {
    const { fetchDistricts, setFormValues, fetchMunicipalities } = this.actions

    const user = yield DataLogicV2.get('userLoggedIn')
    const formData = yield this.get('formValues')

    if (user) {
      const name = user.user.name.split(' ')
      const hasSurName = name.length >= 2
      const surname = (hasSurName && name[name.length - 1]) || ''
      const phone =
        (user.phone_number && user.phone_number.replace('+351', '')) || ''

      const fillForm = {
        personal: {
          ...formData.personal,
          name: { value: name[0], valid: false },
          surName: { value: surname, valid: false },
          nif: { value: user.tax_id, valid: false },
          email: { value: user.user.email || '', valid: false },
          phone: { value: phone, valid: false },
          contact: { value: 'e', valid: false },
          contact_time: { value: '', valid: false },
        },
        billing: {
          ...formData.billing,
          street: { value: user.address, valid: false },
          municipality: { value: user.municipality, valid: false },
          district: { value: user.district, valid: false },
          billingStreet: { value: user.address, valid: false },
          billingMunicipality: { value: user.municipality, valid: false },
          billingDistrict: { value: user.district, valid: false },
        },
      }

      yield put(fetchMunicipalities(user.district, 'district'))
      yield put(fetchMunicipalities(user.district, 'billingDistrict'))

      yield put(setFormValues(fillForm))
    }

    yield put(fetchDistricts())
  },

  workers: {
    *joinTariff(action) {
      const { code } = action.payload
      const { setEditError, setSimulationResults } = this.actions
      const { onClose, formValues } = this.props

      let form = formValues

      let url = PATCH_ENDPOINT.replace(':code', code)
      try {
        // Omit invalid
        delete form.invalid
        const params = { ...csObjectToUnderscore(form) }
        const patch = yield call(axios.patch, url, params)

        yield put(setSimulationResults(csObjectFromUnderscore(patch.data)))
        onClose && onClose()
      } catch (error) {
        yield put(setEditError(error))
        console.log(error)
      }
    },

    *submitForm({ payload }) {
      const {
        setAdhesionResponse,
        setAdhesionError,
        setConfirmationError,
        setSubmitting,
      } = this.actions

      yield put(setSubmitting(true))

      const userCPEandCUI = yield ResultsLogicV2.get('userProfile')

      let form = {}
      Object.keys(payload.form).forEach((key) => {
        form[key] = payload.form[key]
      })
      const arrayBillings = [
        'billing_district',
        'billing_door',
        'billing_floor',
        'billing_municipality',
        'billing_street',
      ]
      /** If billing_address is "e", thats means equal, billing values needs to be empty */
      if (form.billing_address === 'e') {
        Object.keys(form).forEach((key) => {
          if (arrayBillings.find((value) => value === key)) {
            form[key] = ''
          }
        })
      }

      /** If NIF is empty, send nif of user */
      if (!form.tax_id) {
        if (
          this.props.formValues.personal &&
          this.props.formValues.personal.nif
        ) {
          form.tax_id = this.props.formValues.personal.nif.value
        }
      }

      /** If User has CPE added, send to API */
      if (!form.cpe) {
        if (userCPEandCUI && userCPEandCUI.cpe) {
          form.cpe = userCPEandCUI.cpe
        }
      }

      /** If User has CUI added, send to API */
      if (!form.cui) {
        if (userCPEandCUI && userCPEandCUI.cui) {
          form.cui = userCPEandCUI.cui
        }
      }

      if (form.phone_number) {
        form.phone_number = `+351${form.phone_number}`
      } else {
        delete form.phone_number
      }

      // Set form type
      form.type = 'p'

      try {
        if (form.time_cycle === 's') {
          form = omit(form, ['price_list_cycle'])
        }

        form.requires_cui_cpe = false

        if (!payload.omit) {
          // Enviar esta flag se for uma primeira adesao
          form.test_repeated = true
        }

        if (payload.omit && payload.omit.omitRepeated) {
          form.test_repeated = false
        }

        const result = yield call(
          axios.post,
          SUBSCRIBE_PRICE_LIST_ENDPOINT,
          form
        )
        const { data } = result

        sendGevent(
          this.props.isHome ? 'home' : 'simulador',
          'Aderiu',
          'Completou o processo de adesão'
        )

        yield put(setAdhesionResponse(data))
        if (payload.omit && payload.omit.omitRepeated) {
          yield put(setConfirmationError(false))
        }

        payload.callback && payload.callback({ successModal: true })
      } catch (error) {
        if (
          error.response.data &&
          error.response.status === 400 &&
          error.response.data.test_repeated &&
          !!error.response.data.test_repeated.length
        ) {
          yield put(setConfirmationError(true))
        } else {
          if (
            error.response.data &&
            error.response.status === 400 &&
            error.response.data.cui &&
            error.response.data.cpe
          ) {
            error.response.data.cuicpe = ''
            delete error.response.data.cui
            delete error.response.data.cpe
          }

          if (error.response.status !== 400) {
            error.response.data = 'error'
          }

          yield put(setAdhesionError(error))
        }
      } finally {
        yield put(setSubmitting(false))
      }
    },
    *fetchMunicipalities({ payload }) {
      const {
        setMunicipalities,
        setBillingMunicipalities,
        setError,
      } = this.actions
      const { id, type } = payload

      try {
        const res = yield call(axios.get, MUNICIPALITIES_ENDPOINT, {
          params: { limit: 100, district: id },
        })
        const action =
          type === 'district' ? setMunicipalities : setBillingMunicipalities
        yield put(
          action(
            res.data.results.map((mun) => ({ label: mun.name, value: mun.id }))
          )
        )
      } catch (error) {
        yield put(setError(error))
      }
    },

    *fetchDistricts() {
      const { setDistricts, setError } = this.actions

      try {
        const res = yield call(axios.get, DISTRICTS_ENDPOINT, {
          params: { limit: 100 },
        })
        yield put(
          setDistricts(
            res.data.results.map((dis) => ({ label: dis.name, value: dis.id }))
          )
        )
      } catch (error) {
        yield put(setError(error))
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/logic.js